// extracted by mini-css-extract-plugin
module.exports = {"achievementCard":"style_achievementCard__1t6jb","link":"style_link__6m4Da"};